
import {
  type Unit,
  type LabelType,
  type PrintLabelResponse,
  type CreateUnitBySkuRequest,
  type CreateUnitRequest
} from 'types'

import { mainSplitApi } from './redux/mainSplitApi'

export const unitApi = mainSplitApi.injectEndpoints({
  endpoints: (builder) => ({
    createUnit: builder.mutation<Unit, CreateUnitRequest>({
      query: (request) => {
        return {
          url: '/units',
          method: 'POST',
          body: request
        }
      },
      invalidatesTags: ['image']
    }),

    createUnitBySku: builder.mutation<Unit, CreateUnitBySkuRequest>({
      query: (request) => {
        return {
          url: '/units',
          method: 'POST',
          body: request
        }
      },
      invalidatesTags: ['image']
    }),

    updateUnit: builder.mutation<Unit, Unit>({
      query: (unit) => {
        return {
          url: '/units',
          method: 'PUT',
          body: unit
        }
      }
    }),

    printUnitLabel: builder.mutation<PrintLabelResponse, { unitId: string, labelType: LabelType }>({
      query: ({ unitId, labelType }) => {
        return {
          url: `/units/${unitId}/label?type=${labelType}`,
          method: 'POST'
        }
      }
    })
  }),
  overrideExisting: false
})

export const { useCreateUnitMutation, useCreateUnitBySkuMutation, useUpdateUnitMutation, usePrintUnitLabelMutation } = unitApi
